import React, { FC, ReactNode, useCallback } from "react";
import { Accept, FileRejection, useDropzone } from "react-dropzone";

interface IInputFileProps {
  accept?: Accept;
  children: ReactNode;
  onChange?: (
    files: Array<File> | null,
    fileRejections?: FileRejection[]
  ) => void;
}

const InputFile: FC<IInputFileProps> = ({ accept, children, onChange }) => {
  const onDrop = useCallback(
    (acceptedFiles: Array<File>, fileRejections: FileRejection[]) => {
      if (onChange) {
        onChange(acceptedFiles, fileRejections);
      }
    },
    [onChange]
  );

  const { getRootProps, getInputProps } = useDropzone({
    accept,
    onDrop,
  });

  return (
    <div {...getRootProps()}>
      <input {...getInputProps()} />
      {children}
    </div>
  );
};

export default InputFile;
